export const SET_APPLIED_JOBS = 'SET_APPLIED_JOBS';
export const SET_APPLIED_JOBS_LOADING = 'SET_APPLIED_JOBS_LOADING';